/**
 * @desc 重新提交审批
 */
const URL = "/rantion-business";
import http, { updateResponse } from "@/http";
export function request(body: defs.business.PaymentOrderCommitApprovalRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/oms/paymentOrder/commit`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
